import { LoggingService } from '../../shared/services/logging/logging.service';

const log = new LoggingService();

export function isElementVisible(el, holder) {
    holder = holder || document.body;
    const { top, bottom, height } = el.getBoundingClientRect();
    const holderRect = holder.getBoundingClientRect();
    const result = top <= holderRect.top
    ? holderRect.top - top <= height
    : bottom - holderRect.bottom <= height;
    log.verbose({type: 'isElementVisible', el, holder, result});

    return result;
}
